export default __webpack_public_path__ + "static/media/apps-infohub.067cb8e5.svg";